import React from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useUpload } from 'src/hooks';
import { useDropzone } from 'react-dropzone';
import {
  INSERT_LOADING_ATTACHED_NODE_COMMAND,
  INSERT_ATTACHED_NODE_COMMAND,
  AttachedNodePayload,
} from 'src/components/custom/Editor/nodes/AttachedNode';
import { LexicalCommand } from 'lexical';
import { useSetting } from 'src/components/custom/Editor/hooks';

const Attached: React.FC = () => {
  const [editor] = useLexicalComposerContext();
  const { handleUpload } = useUpload();

  const { open } = useDropzone({
    multiple: false,
    async onDrop(files) {
      if (files.length) {
        editor.dispatchCommand(INSERT_LOADING_ATTACHED_NODE_COMMAND, {
          fileName: files[0].name,
        });
        const returned = await handleUpload(files[0]);

        editor.dispatchCommand<LexicalCommand<AttachedNodePayload>>(
          INSERT_ATTACHED_NODE_COMMAND,
          {
            url: returned.url!,
            fileName: returned.origin.name!,
            fileType: returned.origin.type,
          },
        );
      }
    },
  });

  const { editable } = useSetting();

  return (
    <button
      onClick={open}
      className={'toolbar-item spaced '}
      aria-label="Upload"
      disabled={!editable}
    >
      <i className="format upload" style={{ width: 14, height: 14 }} />
    </button>
  );
};

export default Attached;
